<template>
  <div class="paginacion">
    <div :class="{'disabled': current === 1 }" class="back" @click="back()">
      <i class="fa fa-backward"></i>
    </div>
    <div class="currentPage">
      <small>{{current}}</small>
    </div>
    <div class="next" @click="next()">
      <i class="fa fa-forward"></i>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";

  export default {
    name: "CustomPagination",
    computed: {
      ...mapGetters({
        current: "sugeridoCompra/currentPage"
      })
    },
    methods: {
      ...mapActions({
        next: "sugeridoCompra/nextPage",
        back: "sugeridoCompra/backPage"
      })
    }
  }
</script>

<style scoped lang="scss">
  .disabled {
    cursor: help;
  }

  .paginacion {
    width: 200px;
    /*background-color: red;*/
    border-radius: 10px;
    height: 40px;
    padding: 12px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;

    .currentPage {
      background-color: #4d4d4d;
      width: 20px;
      height: 40px;

      small {
        color: white;
        font-weight: bold;
        margin: 5px 7px;
      }
    }

    .back {
      width: 50%;
      height: 40px;
      border-radius: 10px 0 0 10px;
      border-right: 1px solid gray;


      i {
        position: absolute;
        left: 10px;
        top: 12px
      }
    }

    .next {
      border-left: 1px solid gray;
      border-radius: 0 10px 10px 0;

      i {
        position: absolute;
        right: 10px;
        top: 12px
      }
    }

    .back, .next {
      transition: all linear 200ms;
      cursor: pointer;
      position: relative;
      width: 50%;
      height: 40px;
      background-color: $color-corporativo;

      &:hover {
        background-color: $color-corporativo;
        opacity: .5;
      }
    }

    & i {
      color: white;
      cursor: pointer;
    }
  }
</style>
